import * as Sentry from '@sentry/react'

const isProd = import.meta.env.PROD

const logger = {
  log: (...args) => { if (!isProd) console.log(...args) },
  debug: (...args) => { if (!isProd) console.debug(...args) },
  info: (...args) => { if (!isProd) console.info(...args) },
  warn: (...args) => {
    console.warn(...args)
    if (isProd) Sentry.captureMessage(args.map(String).join(' '), 'warning')
  },
  error: (...args) => {
    console.error(...args)
    const err = args.find((a) => a instanceof Error)
    if (err) Sentry.captureException(err)
    else Sentry.captureMessage(args.map(String).join(' '), 'error')
  },
}

export default logger
